import React from 'react';
import { PostalAreas } from '../components';

export default () => {
    return (
        <PostalAreas.Home />
    )
}